import {Component, OnInit} from '@angular/core';
import {CostByTrade} from '../../models/cost-by-trade';
import {
  RealtorPortalService
} from '../../services/network/realtor-portal.service';
declare var Chart: any;

@Component({
  selector: 'app-metrics',
  templateUrl: './metrics.component.html',
  styleUrls: ['./metrics.component.css']
})
export class MetricsComponent implements OnInit {
  costsByTrade: CostByTrade[] = [];
  totalSavings = 0;
  claimsCount = 0;
  activePolicyCount = 0;

  constructor(private realtorPortalService: RealtorPortalService) {}

  ngOnInit() {
    this.realtorPortalService.getTotalSavingsByTrade().then(costsByTrade => {
      this.costsByTrade = costsByTrade;
      this.setupExpensesByTradeChart();
      this.totalSavings =
          costsByTrade.map(i => i.EstimatedRetailCost).reduce((a, b) => a + b);
      this.claimsCount = costsByTrade.map(i => i.Count).reduce((a, b) => a + b);
    });

    this.realtorPortalService.getOrders().then(orders => {
      this.activePolicyCount =
          orders.filter(i => i.Status === 'Active' || i.Status === 'Pending' ||
                             i.Status === 'Suspended')
              .length;
    });
  }

  setupExpensesByTradeChart() {
    if (!document.getElementById('expenses-by-trade-canvas')) {
      setTimeout(() => this.setupExpensesByTradeChart(), 500);
      return;
    }


    const config = {
      type: 'doughnut',
      data: {
        datasets: [
          {
            data: this.costsByTrade.map(i => i.EstimatedRetailCost),
            backgroundColor: [
              '#1b81ac',
              '#759422',
              '#dd8e07',
              '#69767c',
              '#a71926',
              'yellow',
              'pink',
              'blue',
              'red',
              'brown',
            ],
            label: 'Dataset 1'
          }
        ],
        labels: this.costsByTrade.map(i => i.TradeName)
      },
      options: {
        responsive: true,
        legend:
            {position: 'right', enabled: true, labels: {fontColor: '#ffffff'}},
        animation: {animateScale: true, animateRotate: true}
      }
    };

    const d: any = document;
    const ctx = d.getElementById('expenses-by-trade-canvas').getContext('2d');
    new Chart(ctx, config);
  }
}
